export const InboxEmpty = () => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.66536 17.0002H9.90179C10.73 17.0002 11.5112 17.385 12.0159 18.0416L12.4648 18.6254C12.9695 19.282 13.7507 19.6668 14.5789 19.6668H17.4185C18.2467 19.6668 19.0278 19.282 19.5326 18.6254L19.9814 18.0416C20.4862 17.385 21.2674 17.0002 22.0956 17.0002H29.332M29.3719 16.4275L24.942 7.78392C24.4857 6.89354 23.5694 6.3335 22.5689 6.3335H9.42851C8.428 6.3335 7.51168 6.89354 7.05536 7.78392L2.62554 16.4275C2.43264 16.8039 2.33203 17.2207 2.33203 17.6437V23.0002C2.33203 24.4729 3.52594 25.6668 4.9987 25.6668H26.9987C28.4715 25.6668 29.6654 24.4729 29.6654 23.0002V17.6437C29.6654 17.2207 29.5648 16.8039 29.3719 16.4275Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)

export default InboxEmpty
